import { useEffect, useState } from "react";
import { exportLocalArchive, db } from "../lib/db";
import { getDeviceHash, rotateDeviceKey } from "../lib/device";
import { useAppStore } from "../stores/useAppStore";

export function SettingsPage() {
  const { roomId, setRoomId, setConsented, setAttest, setDeviceHash } = useAppStore();
  const [hash, setHash] = useState("…");
  const [quota, setQuota] = useState<string>("unknown");

  useEffect(() => {
    getDeviceHash().then(setHash);
    navigator.storage?.estimate?.().then((estimate) => {
      const used = Math.round((estimate.usage || 0) / 1024 / 1024);
      const total = Math.round((estimate.quota || 0) / 1024 / 1024);
      setQuota(`${used} MB used / ${total} MB quota`);
    });
  }, []);

  const downloadArchive = async () => {
    const archive = await exportLocalArchive();
    const blob = new Blob([JSON.stringify(archive, null, 2)], { type: "application/json" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `afterglow-atlas-export-${new Date().toISOString().slice(0, 10)}.json`;
    a.click();
    URL.revokeObjectURL(url);
  };

  const wipeLocal = async () => {
    await db.delete();
    localStorage.removeItem("afterglow-atlas.v1.consented");
    setConsented(false);
    setAttest("");
    window.location.reload();
  };

  const rotate = async () => {
    rotateDeviceKey();
    const next = await getDeviceHash();
    setHash(next);
    setDeviceHash(next);
    setConsented(false);
    setAttest("");
  };

  return (
    <section className="page-grid settings-page">
      <div className="panel hero-panel">
        <p className="eyebrow">Device-keyed anonymous identity</p>
        <h1>Settings + data</h1>
        <p>Your device key stays in localStorage. The Worker only sees the derived hash below and aggregated session summaries.</p>
      </div>
      <div className="panel">
        <h2>Identity</h2>
        <code className="hash">{hash}</code>
        <label className="field">
          Room / commons namespace
          <input value={roomId} onChange={(event) => setRoomId(event.target.value.trim() || "commons")} />
        </label>
        <p className="small muted">Changing rooms creates a separate live Durable Object and a separate D1 aggregate view.</p>
      </div>
      <div className="panel">
        <h2>Local archive</h2>
        <p className="small muted">Storage estimate: {quota}</p>
        <div className="button-row">
          <button onClick={downloadArchive}>Export JSON</button>
          <button onClick={wipeLocal} className="danger">Erase local archive</button>
          <button onClick={rotate}>Rotate device key</button>
        </div>
      </div>
      <div className="panel">
        <h2>Consent line</h2>
        <p className="consent-line">I consent to contribute anonymous touch/dwell attention traces to a public aggregate commons; I keep my local archive and can erase it.</p>
        <p className="small muted">Production Turnstile is enforced by the Worker when TURNSTILE_SECRET_KEY and SESSION_SIGNING_KEY secrets are set.</p>
      </div>
    </section>
  );
}
